import React, { useState, useEffect } from "react";
import { Badge, Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import { useBizflexAppUrls } from "../../../utils/useBizflexAppUrls";

const Hero = () => {
  const [hover, setHover] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const { registerUrl } = useBizflexAppUrls();

  const images = [
    "/assets/Image11.png",
    "/assets/Image21.png",
    "/assets/Image33.png",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <Box
      color="#fff"
      fontFamily="Poppins"
      w="100%"
      py={{ base: "36px", md: "56px", lg: "76px" }}
    >
      <Flex
        align="center"
        gap={{ base: "30px", md: "60px", lg: "80px" }}
        position="relative"
        flexDir={{ base: "column", md: "row" }}
        w="100%"
      >
        {/* Left Side */}
        <Box w={{ base: "100%", md: "50%" }} position="relative" zIndex={2}>
          {/* Badge */}
          <Badge
            display="flex"
            alignItems="center"
            gap="8px"
            w="fit-content"
            color="#2463EB"
            px="16px"
            py="8px"
            borderRadius="20px"
            fontSize="12px"
            fontWeight={500}
            mb="10px"
            mx={{ base: "auto", md: "0" }}
          >
            <Image
              src="/assets/Star2.svg"
              alt="star"
              w="16px"
              h="16px"
              color="#2463EB"
            />
            Trusted by 10,000+ African Businesses
          </Badge>

          {/* Main Headline */}
          <Text
            fontSize={{ base: "28px", md: "40px", lg: "46px" }}
            textAlign={{ base: "center", md: "start" }}
            fontWeight={700}
            lineHeight={{ base: "38px", md: "57.6px", lg: "67px" }}
            mb={{ base: "16px", md: "20px" }}
          >
            Global & Local Payments for Creators,{" "}
            <span style={{ color: "#FF9D16" }}>Freelancers & Businesses</span>
          </Text>

          {/* Sub-headline */}
          <Text
            mt={{ base: "8px", md: "12px" }}
            color="#dcdcdc"
            textAlign={{ base: "center", md: "start" }}
            fontSize={{ base: "14px", md: "18px" }}
            lineHeight={{ base: "20px", md: "27px" }}
            mb={{ base: "32px", md: "40px" }}
          >
            Open multi-currency accounts, send invoices, and manage your finances -
            built for freelancers, creators & businesses.
          </Text>

          {/* CTA Buttons */}
          <Box mb={{ base: "32px", md: "48px" }}>
            {/* Desktop: Get Started and Download on Android side by side, Download on IOS below */}
            <Box display={{ base: "none", md: "block" }}>
              {/* First Row: Get Started and Download on Android */}
              <Flex
                flexDir="row"
                gap="16px"
                mb="16px"
                justifyContent="flex-start"
                flexWrap="nowrap"
              >
                <a
                  href={registerUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button
                    bg="#2463EB"
                    borderRadius="8px"
                    h="52px"
                    px="32px"
                    color="#fff"
                    fontWeight={400}
                    fontSize="16px"
                    display="flex"
                    alignItems="center"
                    gap="8px"
                    _hover={{ bg: "#1a4fc7" }}
                    onMouseOver={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    w="auto"
                  >
                    Get Started
                    <Image
                      src="/assets/arrow-right.svg"
                      alt="arrow"
                      w="17px"
                      h="17px"
                    />
                  </Button>
                </a>

                <a
                  href="https://play.google.com/store/apps/details?id=com.fastamoniorg.bizflex"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button
                    bg="#0F172B"
                    variant="outline"
                    borderRadius="8px"
                    h="52px"
                    px="24px"
                    color="#fff"
                    fontWeight={400}
                    fontSize="14px"
                    display="flex"
                    alignItems="center"
                    gap="4px"
                    _hover={{ bg: "#1a1f2e" }}
                    border="0.75px solid #E5E7EB"
                    w="auto"
                  >
                    Download on Android
                    <Image
                      src="/assets/android.svg"
                      w="20px"
                      h="14px"
                      alt="android"
                    />
                  </Button>
                </a>
              </Flex>

              {/* Second Row */}
              <Flex
                flexDir="row"
                gap="16px"
                justifyContent="flex-start"
              >
                <a
                  href="https://apps.apple.com/us/app/bizflex-africa/id6754340965"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button
                    bg="#0F172B"
                    variant="outline"
                    borderRadius="8px"
                    h="52px"
                    px="24px"
                    color="#fff"
                    fontWeight={400}
                    fontSize="14px"
                    display="flex"
                    alignItems="center"
                    gap="4px"
                    _hover={{ bg: "#1a1f2e" }}
                    border="0.65px solid #E5E7EB"
                    w="auto"
                  >
                    Download on IOS
                    <Image
                      src="/assets/apple.svg"
                      w="20px"
                      h="14px"
                      alt="apple"
                    />
                  </Button>
                </a>
              </Flex>
            </Box>

            {/* Mobile */}
            <Flex
              flexDir="row"
              gap="12px"
              mb="12px"
              justifyContent="center"
              flexWrap="nowrap"
              display={{ base: "flex", md: "none" }}
            >
              <a
                href={registerUrl}
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  bg="#2463EB"
                  borderRadius="8px"
                  h="44px"
                  px="24px"
                  color="#fff"
                  fontWeight={400}
                  fontSize="14px"
                  display="flex"
                  alignItems="center"
                  gap="8px"
                  _hover={{ bg: "#1a4fc7" }}
                  onMouseOver={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  w="auto"
                >
                  Get Started
                  <Image
                    src="/assets/arrow-right.svg"
                    alt="arrow"
                    w="17px"
                    h="17px"
                  />
                </Button>
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.fastamoniorg.bizflex"
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  bg="#0F172B"
                  variant="outline"
                  borderRadius="8px"
                  h="44px"
                  px="20px"
                  color="#fff"
                  fontWeight={400}
                  fontSize="12px"
                  display="flex"
                  alignItems="center"
                  gap="4px"
                  _hover={{ bg: "#1a1f2e" }}
                  border="0.65px solid #E5E7EB"
                  w="auto"
                >
                  Download on Android
                  <Image
                    src="/assets/android.svg"
                    w="18px"
                    h="13px"
                    alt="android"
                  />
                </Button>
              </a>
            </Flex>

            {/* Mobile */}
            <Flex
              flexDir="row"
              gap="12px"
              justifyContent="flex-start"
              display={{ base: "flex", md: "none" }}
            >
              <a
                href="https://apps.apple.com/us/app/bizflex-africa/id6754340965"
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  bg="#0F172B"
                  variant="outline"
                  borderRadius="8px"
                  h="44px"
                  px="20px"
                  color="#fff"
                  fontWeight={400}
                  fontSize="12px"
                  display="flex"
                  alignItems="center"
                  gap="4px"
                  _hover={{ bg: "#1a1f2e" }}
                  border="0.65px solid #E5E7EB"
                  w="auto"
                >
                  Download on IOS
                  <Image
                    src="/assets/apple.svg"
                    w="18px"
                    h="13px"
                    alt="apple"
                  />
                </Button>
              </a>
            </Flex>
          </Box>

          {/* Feature Icons */}
          <Flex
            gap={{ base: "12px", md: "24px" }}
            flexDir={{ base: "row", md: "row" }}
            justifyContent={{ base: "center", md: "flex-start" }}
            flexWrap="wrap"
          >
            <Flex align="center" gap={{ base: "6px", md: "4px" }}>
              <Image
                src="/assets/shield.svg"
                w={{ base: "16px", md: "24px" }}
                h={{ base: "16px", md: "18px" }}
                alt="security"
              />
              <Text fontSize={{ base: "11px", md: "14px" }} color="#dcdcdc">
                Bank-grade Security
              </Text>
            </Flex>
            <Flex align="center" gap={{ base: "6px", md: "4px" }}>
              <Image
                src="/assets/time.svg"
                w={{ base: "16px", md: "24px" }}
                h={{ base: "16px", md: "18px" }}
                alt="security"
              />
              <Text fontSize={{ base: "11px", md: "14px" }} color="#dcdcdc">
                Setup in 5 minutes
              </Text>
            </Flex>
            <Flex align="center" gap={{ base: "6px", md: "4px" }}>
              <Image
                src="/assets/tag.svg"
                w={{ base: "16px", md: "24px" }}
                h={{ base: "16px", md: "18px" }}
                alt="security"
              />
              <Text fontSize={{ base: "11px", md: "14px" }} color="#dcdcdc">
                Transparent fees
              </Text>
            </Flex>
          </Flex>
        </Box>

        {/* Right Side - Image */}
        <Box
          w={{ base: "100%", md: "50%" }}
          position="relative"
          display="flex"
          justifyContent={{ base: "center", md: "flex-end" }}
          overflow={{ base: "visible", md: "hidden" }}
        >
          <Box
            position="relative"
            w={{ base: "100%", md: "100%" }}
            maxW={{ base: "100%", md: "600px" }}
            h={{ base: "auto", md: "600px" }}
            minH={{ base: "300px", md: "600px" }}
            overflow={{ base: "visible", md: "hidden" }}
          >
            {/* Mobile */}
            <Image
              src={images[currentImageIndex]}
              w="100%"
              h={{ base: "auto", md: "600px" }}
              objectFit="contain"
              borderRadius="8px"
              alt="African business owner using digital payments platform"
              display={{ base: "block", md: "none" }}
            />
            {/* Desktop */}
            {images.map((image, index) => (
              <Image
                key={index}
                src={image}
                w="100%"
                h="600px"
                objectFit="contain"
                borderRadius="8px"
                alt="African business owner using digital payments platform"
                position="absolute"
                top="0"
                left="0"
                opacity={currentImageIndex === index ? 1 : 0}
                pointerEvents="none"
                display={{ base: "none", md: "block" }}
              />
            ))}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default Hero;
